module.exports = __webpack_public_path__ + "media/images/bank_images/itau-706a24d44fa17ab5926ed9d01e78a01f.png";